import {
  CertificationEventCode,
  DutyEventCode,
  EngineEventCode,
  IntermediateEventCode,
  LogEventType,
  LogRecordStatus,
  LoginEventCode,
  PersonalUseEventCode,
} from '@fleet-beat/core';

export interface UpdateLogRecord {
  truckId: string;
  eventType: LogEventType;
  eventCode:
    | PersonalUseEventCode
    | DutyEventCode
    | CertificationEventCode
    | LoginEventCode
    | EngineEventCode
    | IntermediateEventCode;
  startedAt: string;
  endedAt: string;
  status: `${LogRecordStatus}`;
  notes: string;
  isLocked: boolean;
  odometer: number;
  engineHours: number;
  lat: string;
  lon: string;
  address: string;
  shippingDocument: string;
}
